
    <div [@TopNotificationState]="isOpen ? 'open' : 'closed'" *ngIf="isSessionTimeoutType" id="SessionTimeoutNotification" class="alert alert-{{ style }}">
        <h4>Your login session is about to expire.</h4>
        <p>You will be logged out in <span>{{ timeLeft }}</span> seconds.</p>
        <a class="btn btn-primary mx-2" [href]="['/logout']">Logout</a> <span class=" mx-2 btn btn-secondary" (click)="refreshLogin()">Keep me signed in</span>
    </div>

